<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<template>
  <div>
    <h2>CRÉDITOS</h2>
    <h4>Universidad Popular Autónoma del Estado de Puebla</h4>
    <p><span class='text-strong'>Emilio José Baños Ardavín</span><br>Rector</p>
    <p><span class='text-strong'>Mariano Sánchez Cuevas</span><br>Vicerrector Académico</p>
    <p><span class='text-strong'>Francisco Eugenio Urrutia Albisua</span><br>Vicerrector de Investigación</p>
    <p><span class='text-strong'>Luis Fernando Roldán de la Tejera</span><br>Director de Formación, Cultura y Liderazgo</p>
    
    <h4>Museo UPAEP</h4>
    <p><span class='text-strong'>Evelin Flores Rueda</span><br>Dirección</p>
    <p><span class='text-strong'>Mariana Cruz Ugarte</span><br>Coordinación de Comunicación Educativa</p>
    <p><span class='text-strong'>Rodrigo Robledo Rojano</span><br>Coordinación de Colecciones</p>
    <p><span class='text-strong'>Tere Itzel Alva Juárez</span><br>Coordinación de Promoción y Difusión</p>
    <p><span class='text-strong'>Lourdes Gómez Mendoza</span><br>Mediadora</p>
    <p><span class='text-strong'>Ricardo González Zacarías</span><br>Servicios Generales</p>
    
    <h4>Museo Nacional de Historia “Castillo de Chapultepec”</h4>
    <p><span class='text-strong'>Salvador Rueda Smither</span><br>Director</p>
    
    <h4>Colaboración Académica</h4>
    <p><span class='text-strong'>David Sánchez Sánchez</span><br>Director de la Lic. en Humanidades y Gestión Cultural<br>Curaduría de la Sala Acontecimiento Guadalupano</p>
    <p><span class='text-strong'>Fabián Valdivia Pérez</span><br>Investigador<br>Curaduría de la salas Caída de Tenochtitlán y Consumación de la Independencia</p>
    <p><span class='text-strong'>Eduardo Merlo Juárez</span><br>Asesor Cultural UPAEP</p>
    
    <h4>Producción Audiovisual</h4>
    <p><span class='text-strong'>Francisco Reyes Paredes</span><br><span class='text-strong'>Alma Magaly Cosio Vázquez</span><br><span class='text-strong'>Ana Carolina Aguilar Nicolás</span><br>Traducción Náhuatl. Alumnos UPAEP</p>
    <p><span class='text-strong'>Mariana Cruz Ugarte</span><br>Traducción inglés</p>
    <p><span class='text-strong'>Grace Gutiérrez Arias</span><br>Compañía de Teatro UPAEP</p>
    <p><span class='text-strong'>Alejandro Cossío</span><br>COSSIRIS Arte & Entretenimiento</p>
    <p><span class='text-strong'>Osiris Cambrani</span><br>Coordinación de actores</p>
    <p><span class='text-strong'>José Pablo Aguilar Garduño</span><br><span class='text-strong'>Alejandro Vargas Osorio</span><br>Voz en off</p>
    <p><span class='text-strong'>Carlos Antonio Tecuapetla Gallegos</span><br><span class='text-strong'>Jorge Enrique Pérez Osio</span><br>Edición</p>
    
    <h4>Diseño Gráfico</h4>
    <p><span class='text-strong'>Vanessa Díaz Jorge</span><br>Cuadernillo</p>
    
    <h4>Colaboraciones Especiales</h4>
    <ul>
    <li>EDIS Interactive</li>
    <li>Una Apuesta de Futuro</li>
    <li>Laboratorio de Medios Audiovisuales y Humanidades UPAEP</li>
    <li>Bellas Artes UPAEP</li>
    <li>Museos Puebla</li>
    <li>UPRESS</li>
    <li>IDD UPAEP</li>
    <li>CNEP</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "Sala1m1",
  data() {
    return {};
  },
  methods: {
    imageClicked(idx) {
      this.$emit("onImageClicked", idx);
    }
  },
  components: {},
  props: {},
  mounted() {},
};
</script>
